:host {
  display: inline-flex;
}

sl-icon {
  display: inline-flex;
  // --sl-icon-width: var(--fs-400, 1rem);
  // --sl-icon-height: var(--fs-400, 1rem);

  &[library='lucide'] {
    width: var(--sl-icon-width);
    height: var(--sl-icon-height);

    &[size='small'] {
      --sl-icon-width: var(--fs-400, 1rem);
      --sl-icon-height: var(--fs-400, 1rem);
    }

    &[size='medium'] {
      --sl-icon-width: var(--fs-500, 1.125rem);
      --sl-icon-height: var(--fs-500, 1.125rem);
    }

    &[size='large'] {
      --sl-icon-width: var(--fs-600, 1.5rem);
      --sl-icon-height: var(--fs-600, 1.5rem);
    }

    &[size='inherit'] {
      width: 100%;
      height: 100%;
    }
  }

  &[library='custom'] {
    width: var(--sl-icon-width);
    height: var(--sl-icon-height);

    &[size='small'] {
      --sl-icon-width: var(--fs-400, 1rem);
      --sl-icon-height: var(--fs-400, 1rem);
    }

    &[size='medium'] {
      --sl-icon-width: var(--fs-500, 1.125rem);
      --sl-icon-height: var(--fs-500, 1.125rem);
    }

    &[size='large'] {
      --sl-icon-width: var(--fs-600, 1.5rem);
      --sl-icon-height: var(--fs-600, 1.5rem);
    }

    &[size='inherit'] {
      width: inherit;
      height: inherit;
    }
  }

  &[library='fa'] {
    font-size: var(--font-size);
    line-height: var(--line-height);

    &[size='small'] {
      --font-size: var(--fs-400, 1rem);
      --line-height: var(--fs-400, 1rem);
    }

    &[size='medium'] {
      --font-size: var(--fs-500, 1.125rem);
      --line-height: var(--fs-500, 1.125rem);
    }

    &[size='large'] {
      --font-size: var(--fs-600, 1.5rem);
      --line-height: var(--fs-600, 1.5rem);
    }

    &[size='inherit'] {
      font-size: inherit;
      line-height: inherit;
    }
  }

  // width: var(--sl-icon-width);
  // height: var(--sl-icon-height);
}
